// extracted by mini-css-extract-plugin
export default {"contents":"GU-z","sectionHeading":"HU-z"};